<template>
    <div>
        <el-container>
            <el-aside width="200px">
                <DxLeftMenu :theme="layoutConfig.siderTheme"></DxLeftMenu>
            </el-aside>
            <el-container>
                <el-header style="background-color: #545c64">
                    <Header @openSetting="openSetting = true"></Header>
                </el-header>

                <el-main>
                    <router-view></router-view>
                </el-main>

                <el-footer>
                    <DxFooter></DxFooter>
                </el-footer>
            </el-container>
        </el-container>
    </div>
</template>
<script>
    import Header from './common/include/_header'
    import appLayoutSetting from './common/include/modules/app-layout-setting'
    import DxLeftMenu from './common/include/_left'
    import DxFooter from './common/include/_footer'
    import SysTabs from '../dxrj.sdk/common/sys-tabs'
    import { mapState } from 'vuex'
    export default {
        data () {
            return {
                loading: true,
                layoutConfig: {
                    siderTheme: 'dark',
                    showSystab: true,
                    headerFixed: true,
                    siderFixed: true
                }
            }
        },
        computed: {
            ...mapState(['siderCollapsed'])
        },
        components: {
            Header,
            DxLeftMenu,
            SysTabs,
            DxFooter,
            appLayoutSetting
        },
        mounted () {
        },
        methods: {

        }
    }
</script>
<style lang='less' scoped>
    .h-modal-header{
        color: #fff;
        background: linear-gradient(41deg, #409eff, #66B1FF);
    }
    .el-aside{
        width: 200px;
        height: 100vh;
        background: rgb(84, 92, 100);
    }
    .el-aside::-webkit-scrollbar {
        width: 0px;
    }
    .el-container{
        /*height: calc(100vh - 60px);*/
        height: 100vh;
        overflow: hidden;
        .el-main::-webkit-scrollbar {
            width: 0px;
        }
    }
    .copyright{
        margin: 0px auto;
        text-align: center;
    }
</style>
